var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// @flow
import React, { Component } from 'react';
import sortBy from 'lodash/sortBy';
import { Wrapper, Tile, Image, TextWrapper, Descripction, Banner, } from './styles';
var TilesSmall = /** @class */ (function (_super) {
    __extends(TilesSmall, _super);
    function TilesSmall() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TilesSmall.prototype.render = function () {
        var _a = this.props, tiles = _a.tiles, bannerUrl = _a.bannerUrl, session = _a.session;
        return (_jsxs(Wrapper, __assign({ hasBanner: Boolean(bannerUrl) }, { children: [sortBy(tiles, 'sort').map(function (tile) { return (_jsxs(Tile, __assign({ to: "/" + session.uuid + tile.targetUrl }, { children: [_jsx(Image, { src: tile.imageUrl }, void 0), _jsxs(TextWrapper, { children: [tile.headline, _jsx(Descripction, { children: tile.description }, void 0)] }, void 0)] }), tile.sort)); }), bannerUrl && _jsx(Banner, { src: bannerUrl }, void 0)] }), void 0));
    };
    return TilesSmall;
}(Component));
export default TilesSmall;
